import { getEmployeeFields, getdirectusUserFields } from "components/user/config";
import {
  getItemFromCollection,
  updateItemInCollection,
} from "directus/src/operations";

export const TASK_FIELDS = [
  "id",
  "title",
  "description",
  "status",
  "type",
  "due_date",
  "date_resolved",
  "date_created",
  "attachments.file.id",
  "attachments.file.type",
  "attachments.file.filename_download",
  getEmployeeFields("assignee"),
  getdirectusUserFields("user_created"),
  "collection.collection",
  "collection.item:jobs.name",
  "collection.item:jobs.id",
  "collection.item:projects.name",
  "collection.item:projects.project_id",
  "collection.item:billables.id",
  "collection.item:daily_work_capacity.id",
  "collection.item:daily_work_capacity.date",
  "collection.item:job_extensions.id",
];

export async function fetchTaskDetails(taskId) {
  try {
    const res = await getItemFromCollection("tasks", taskId, {
      fields: TASK_FIELDS,
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function updateTask(taskId, item) {
  try {
    const res = await updateItemInCollection("tasks", taskId, item, {
      fields: TASK_FIELDS,
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobExtensionDetails(extensionId) {
  try {
    const res = await getItemFromCollection("job_extensions", extensionId, {
      fields: ["id", "job", "job.id", "job.name"],
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

